import script from "./Advertisement.vue?vue&type=script&setup=true&lang=js"
export * from "./Advertisement.vue?vue&type=script&setup=true&lang=js"

import "./Advertisement.vue?vue&type=style&index=0&id=7c22459b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c22459b"]])

export default __exports__